import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search-button',
  imports: [MatButtonModule, MatIconModule, MatTooltipModule],
  standalone: true,
  styleUrl: './search-button.component.scss',
  templateUrl: './search-button.component.html',
})
export class SearchButtonComponent {
  dialog = inject(Router);

  openSearchModal() {
    this.dialog.navigate(['/search']);
  }
}
